import BACKGROUMND from "../assets/images/bg_main.png"
import FAITH from "../assets/images/faith.png"
import FAITH_SUCCESS from "../assets/images/faith_success.png"


const IMAGES = {
    "BACKGROUMND":BACKGROUMND,
    "FAITH":FAITH,
    "FAITH_SUCCESS":FAITH_SUCCESS,

}

export default IMAGES;